import { render, staticRenderFns } from "./MessageAccount.vue?vue&type=template&id=40cebcfe&scoped=true&"
import script from "./MessageAccount.vue?vue&type=script&lang=js&"
export * from "./MessageAccount.vue?vue&type=script&lang=js&"
import style0 from "./MessageAccount.vue?vue&type=style&index=0&id=40cebcfe&lang=scss&scoped=true&"
import style1 from "./MessageAccount.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cebcfe",
  null
  
)

export default component.exports